import { createContext } from 'react';

const SiteHeaderContext = createContext({});

export { SiteHeaderContext };
